import useDevice from 'hooks/useDevice';
import React from 'react';

export default function LinkToCallMobile({ children, href, className }) {
	const { isMobile } = useDevice();
	let props = {};
	if (isMobile) {
		props.href = href;
	}
	return (
		<a {...props} className={className}>
			{children}
		</a>
	);
}
